import { Button, Checkbox, FormControl, FormControlLabel, FormHelperText, InputLabel, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import React from 'react'
import { useSelector } from 'react-redux';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { saveHealthCheck, updateHealthCheck } from './edit-project-actions';
import { useParams } from 'react-router-dom';

const EditProjectHealthCheck = (props) => {

    const state = useSelector(state => state.pages.editProject)
    const healthCheck = state.healthCheck
    const { project } = useParams()

    return (
        <form onSubmit={e => saveHealthCheck(e, project)}>
            <div className="grid gap-4  ">
                <div className=" border-b pb-4 bg-gray-100 p-4">
                        <p className="text-md text-gray-800">Health Check enables an endpoint to check whether the project has recently received new documents, with the goal of alerting if new document ingestion has been stopped.</p>
                </div>
                <div className="grid grid-cols-1 gap-4 p-4">
                    <div className="grid gap-4">
                        <div className="flex flex-row gap-4 pl-1">
                            <FormControl variant="outlined" size="small" fullWidth={false}>
                                <FormControlLabel
                                    labelPlacement="end"
                                    label="Enabled"
                                    control={
                                        <Checkbox
                                            id="enabled"
                                            name="enabled"
                                            className=""
                                            checked={healthCheck.enabled}
                                            onChange={updateHealthCheck}
                                        />
                                    }
                                />
                            </FormControl>
                        </div>
                        <div className="flex gap-4">
                            <FormControl required variant="outlined" size="large" fullWidth={false}>
                                <TextField
                                    required
                                    disabled={!healthCheck.enabled}
                                    size="medium"
                                    className="w-[300px]"
                                    type="number"
                                    name="threshold"
                                    label="Threshold"
                                    value={healthCheck.threshold}
                                    onChange={updateHealthCheck}
                                />
                            </FormControl>
                            <div className="flex flex-row gap-4 items-center" >
                                <FormControl size="medium" required>
                                    <InputLabel id="incident-label">Threshold Unit</InputLabel>
                                    <Select
                                        required
                                        disabled={!healthCheck.enabled}
                                        label="Threshold Unit"
                                        className="w-48"
                                        name="thresholdUnit"
                                        placeholder='Threshold Unit'
                                        value={healthCheck.thresholdUnit}
                                        onChange={updateHealthCheck}
                                    >
                                        <MenuItem value="MILLISECONDS" disabled><em>SELECT</em></MenuItem>
                                        <MenuItem value="MILLISECONDS">MILLISECONDS</MenuItem>
                                        <MenuItem value="SECONDS">SECONDS</MenuItem>
                                        <MenuItem value="MINUTES">MINUTES</MenuItem>
                                    </Select>
                                </FormControl>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="p-4 text-right bg-gray-100 border-t border-gray-300">
                <Button variant="contained" type='submit' className="text-dark-500" >SAVE</Button>
            </div>
        </form>
    )
}

export default EditProjectHealthCheck;